var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.url
    ? _c(
        "div",
        {
          staticClass: "stock-images-thumbnail",
        },
        [
          _c(
            "div",
            {
              style: {
                width: _vm.width,
              },
            },
            [
              _c("img", {
                style: {
                  "object-fit": _vm.contain ? "contain" : "cover",
                },
                attrs: {
                  src: _vm.url,
                  role: "presentation",
                },
              }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }